export default () => import(/* webpackChunkName: 'coffee/app/agreement/SubContent' */ './SubContent');
